import { Form, FormInstance, FormProps, Input, Modal, notification, Select, Spin, TreeSelect } from "antd"
import { useForm } from 'antd/lib/form/Form';
import * as UnitApi from '../../../../api/unit/unitApi';
import { useEffect, useRef, useState } from "react";
import useToast from "../../../../hook/useToast";
import useLoading from "../../../../hook/useLoading";
import LoadingSpin from "../../../../components/LoadingSpin";
import { CloseOutlined } from '@ant-design/icons';
import './styles.scss'

interface ModalProps {
  isOpen: boolean
  dataListNationwide: []
  onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
  closeModal: () => void
}

const ModalCreateUnit: React.FC<ModalProps> = ({
  isOpen,
  dataListNationwide,
  onSubmitFormModal,
  closeModal
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);
  const [value, setValue] = useState<string>();
  const pushToast = useToast();
  const [checkloading, setCheckloading] = useState<boolean>(false)
  const [inputValue, setInputValue] = useState('');
  const [tags, setTags] = useState<string[]>([]);

  const updateFormValue = (newTags: string[]) => {
    setTags(newTags);

    // form.setFieldsValue({
    //   b7EntityCode: newTags,
    // });
  };

  const handleAddTag = () => {
    const value = inputValue.trim();

    if (!value) return;

    // không cho trùng
    if (tags.includes(value)) {
      setInputValue('');
      return;
    }

    const newTags = [...tags, value];

    updateFormValue(newTags);
    setInputValue('');
  };

  const handleRemoveTag = (tag: string) => {
    const newTags = tags.filter(item => item !== tag);

    updateFormValue(newTags);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddTag();
    }
  };


  const onChange = (newValue: string) => {
    setValue(newValue);
  };
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };
  const onFinish: FormProps["onFinish"] = async (values) => {

    if (!tags.length) pushToast('Bạn cần nhập ít nhất 1 mã B7!', "error")

    setCheckloading(true)
    const result = await UnitApi.addUnit(values.codeaffiliated, values.nameaffiliated, values.parentId, tags);
    if (result?.status) {
      setCheckloading(false)
      onSubmitFormModal(true, result?.message)
    } else {
      onSubmitFormModal(false, result?.message)
      setCheckloading(false)
    }
  };

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
      setCheckloading(false)
    } else {
      setCheckloading(false)
    }
  }, [isOpen])
  return (
    <Modal
      title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
        <span className="text-base text-344054 fw-500 font-medium">Tạo mới Đơn vị</span>
        <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
      </div>}
      open={isOpen}
      onCancel={closeModal}
      centered
      className="w-modal modal-content-creat-area ant-modal-size"
      closeIcon={false}
      footer={<div className="bg-FCFCFD d-flex justify-end align-center py-2 px-6 w-full border-t-F0F0F0 gap-2">
        <button className="text-sm text-344054 border-F2F4F7 bg-white h-8 px-15-px font-regular rounded-2 shadow-btn-save" onClick={closeModal}>Huỷ</button>
        <button
          className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px font-regular shadow-btn-save"
          onClick={submitForm}
          disabled={checkloading}
        >
          Xác nhận
        </button>
      </div>}
    >
      <Form
        form={form}
        ref={inputRef}
        onFinish={onFinish}
        initialValues={{ remember: true }}
      >
        <LoadingSpin
          checkLoading={checkloading}
        />
        <div className="d-flex flex-column gap-18-px p-6">
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Mã đơn vị:
            </p>
            <Form.Item
              name="codeaffiliated"
              rules={[{ required: true, message: 'Nhập mã đơn vị!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Mã đơn vị"
                className="custom-input-css custom-page-css border "
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            <p className="text-sm font-regular text-344054 d-flex gap-2 align-center mb-1">
              <span className="text-F5222D">*</span>
              Mã pháp nhân B7:
            </p>

            <Input
              value={inputValue}
              placeholder="Mã pháp nhân B7"
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              className="b7-input"
            />

            {!!tags.length && (
              <div className="b7-tags custom-page-css scroll-custom pb-1">
                {tags.map(tag => (
                  <div key={tag} className="b7-tag custom-page-css max-w-full "
                  >
                    <span className="custom-page-css max-w-full text-truncate overflow-hidden">{tag}</span>
                    <CloseOutlined
                      className="b7-tag-close"
                      onClick={() => handleRemoveTag(tag)}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Tên đơn vị:
            </p>
            <Form.Item
              name="nameaffiliated"
              rules={[{ required: true, message: 'Nhập tên đơn vị!' }]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Tên đơn vị"
                className="custom-input-css custom-page-css border "
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
              <span className="text-F5222D">*</span>
              Chọn văn phòng điều hành:
            </p>
            <Form.Item
              name="parentId"
              rules={[{ required: true, message: 'Chọn văn phòng điều hành!' }]}
              className="m-none-form-item text-explan"
            >
              <TreeSelect
                showSearch
                value={value}
                placeholder="Chọn văn phòng điều hành"
                allowClear
                treeDefaultExpandAll={false}
                onChange={onChange}
                treeData={dataListNationwide}
                className="custom-page-css border rounded overflow-hidden "
                filterTreeNode={(input: string, option: any) =>
                  typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }

              />
            </Form.Item>
          </div>


        </div>
      </Form>
    </Modal>
  )
}
export default ModalCreateUnit
